export const messages = {
  couldNotFindEditor: {
    id: 'authoring.editorpage.selecteditor.error',
    defaultMessage: 'Error: Could Not find Editor',
    description: 'Error Message Dispayed When An unsopported Editor is desired in V2',
  },
};

export default messages;
